/*
 Created by qing on 2022/5/12 下午4:10
 Des: 第三方表格
 */

import BaseItem from "../BaseItem"
import {
  DATA_TYPE__ARRAY, DATA_TYPE__JSON,
  FORM_ITEM__LARK_APPROVAL, FORM_ITEM__TABLE, FORM_ITEM__THIRD_DATA_TABLE
} from "../types"

class ThirdDataTable extends BaseItem {

  constructor() {
    super()
    this.value = {}

    this.requestUrl = "" // 请求的url
    this.methodType = 0
    this.headerList = []
    this.paramType = 0
    this.paramList = []
    this.requestBody = ''
    this.mainColor = 'rgba(233, 237, 242, 1)'
    this.headerColor = 'rgba(122, 128, 136, 1)'
    this.contentColor = 'rgba(65, 68, 72, 1)'
    this.alignment = 'left'
    this.refreshFieldIdList = []
    this.defaultValue = {}
  }

  get title() {
    return this.fieldTitle || ThirdDataTable._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

ThirdDataTable._title = '第三方表格'
ThirdDataTable.type = FORM_ITEM__THIRD_DATA_TABLE
ThirdDataTable.use = true
ThirdDataTable.prototype.icon = 'el-icon-video-play'

ThirdDataTable.prototype.type = ThirdDataTable.type
ThirdDataTable.prototype.dataType = DATA_TYPE__JSON
ThirdDataTable.prototype.defaultValueList = []

ThirdDataTable.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
ThirdDataTable.prototype.getValue = function () {
  return this.value
}
ThirdDataTable.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || []
}
ThirdDataTable.prototype.setConf = function (opts) {
  if (opts) {
    this.setBase(opts)
    this.requestUrl = opts.requestUrl
    this.methodType = opts.methodType
    this.headerList = opts.headerList
    this.paramType = opts.paramType
    this.paramList = opts.paramList
    this.requestBody = opts.requestBody
    this.mainColor = opts.mainColor
    this.headerColor = opts.headerColor
    this.contentColor = opts.contentColor
    this.alignment = opts.alignment
    this.refreshFieldIdList = opts.refreshFieldIdList
  }
}
ThirdDataTable.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    requestUrl: this.requestUrl,
    methodType: this.methodType,
    headerList: this.headerList,
    paramType: this.paramType,
    paramList: this.paramList,
    requestBody: this.requestBody,
    mainColor: this.mainColor,
    headerColor: this.headerColor,
    contentColor:this.contentColor,
    alignment: this.alignment,
    refreshFieldIdList: this.refreshFieldIdList
  }
}
ThirdDataTable.prototype.valueToString = function (value) {
  return ''
}
export default ThirdDataTable
